// The phone's screens: the Dock at the bottom, its menu, the frame kept on the
// visible part of the screen while the keyboard is up, and the parts' pieces
// that only a phone draws. A separate entry (`@trameria/ui-core/phone`, with
// `@trameria/ui-core/phone.css`): only a host that serves phones (cloud)
// imports it and hands it to the shell (`createMeApp({ extensions: { phone:
// phoneKit() } })`); the offline edition never imports it, so none of this is
// in its bundle (apps/local checks that on every build).
//
// Nothing outside this folder imports it; it imports the shell and the parts.
import { RUN_DRAWER_SLOT } from "../agent-chat/run-drawer-port";
import { TURN_DRAWER_SLOT } from "../agent-chat/turn/drawer-port";
import { lazyScreen } from "../app/lazy";
import { MEDIA_MORE_SLOT } from "../documents/blocks/media/media-more-port";
import type { PhoneKit } from "../shell/phone";
import { PageDockButton } from "./dock-row";
import { DockSlot, DockUp } from "./dock-slot";
import { PhoneFrame } from "./frame";
import { MediaMoreDrawer } from "./media";
import { PhoneOverlay } from "./overlay";
import { RunPills } from "./run-pills";
import { TopDock } from "./top-dock";
import { TurnDrawer } from "./turn-drawer";

export { phoneDockSettings } from "./settings";

// With the editor's code, loaded with the document screen that draws it.
const DocUndoButtons = lazyScreen(
  () => import("./documents"),
  "DocUndoButtons",
);

/** The phone's screens for `extensions.phone`. */
export function phoneKit(): PhoneKit {
  return {
    Frame: PhoneFrame,
    DockSlot,
    DockUp,
    Button: PageDockButton,
    Overlay: PhoneOverlay,
    TopDock,
    slots: {
      "documents.undo": DocUndoButtons,
      [TURN_DRAWER_SLOT]: TurnDrawer,
      [RUN_DRAWER_SLOT]: RunPills,
      [MEDIA_MORE_SLOT]: MediaMoreDrawer,
    },
  };
}
